import { createContext } from 'react'

export const BasePathContext = createContext('/')
